<!-- 考核任务 -->
<template>
    <div class="fuzzy-matching-box">
      <div v-if="title == '考核任务'" style="padding-top: 50px;">
      <div class="fuzzy-matching-top">
        <el-row class="top-first-line the-second-line">
          <el-col :span="5">
            <el-form-item label="任务名称:">
                <el-input v-model="form.name" placeholder='请输入任务名称搜索'></el-input>
            </el-form-item>
          </el-col >
          <el-button type="primary" size="medium" class="query-button" @click="inquiryClick">查询</el-button>
          <el-button type="primary" size="medium" class="query-button" @click="addrTask">新增任务</el-button>
            <el-col :span="5">
          </el-col >
            <el-col :span="5">
            </el-col >
            <el-col :span="5">
            </el-col >
        </el-row>
      </div>
      <div class="fuzzy-matching-bottom">
        <el-row class="list">
           <el-table
              stripe
              :border="true"
              :header-cell-style="{background:'#EDF6FF',color:'#000',}"
              ref="multipleTable"
              :data="tableData"
              tooltip-effect="dark"
              style="width: 100%"
              v-loading="loading"
              @selection-change="handleSelectionChange">
            <el-table-column
              prop="name"
              label="任务名称"
              >
            </el-table-column>
            <el-table-column
              label="考核对象"
              >
              <template #default="scope">
              <span v-if="scope.row.checkUserType == 'student'">学生</span> 
              <span v-if="scope.row.checkUserType == 'class'">班级</span>
              <span v-if="scope.row.checkUserType == 'teacher'">教师</span>
            </template>
            </el-table-column>
            <el-table-column
             label='考核周期'
              >
              <template #default="scope">
              <span v-if="scope.row.checkPeriodType == 'day'">天</span> 
              <span v-if="scope.row.checkPeriodType == 'week'">周</span>
              <span v-if="scope.row.checkPeriodType == 'month'">月</span>
              <span v-if="scope.row.checkPeriodType == 'unlimited'">不限</span>
            </template>
            </el-table-column>
            <el-table-column
              label="考核人"
              >
              <template #default="scope">
              <span v-if="scope.row.approveUserType == 'all'">全员</span> 
            </template>
            </el-table-column>
            <el-table-column
              prop="initialSore"
              label="初始分值"
              >
            </el-table-column> 
            <el-table-column
              prop="scoreUpLimit"
              label="累计得分上限"
              >
              <template #default="scope">
              <span v-if="scope.row.scoreUpLimit == null">不限</span> 
            </template>
            </el-table-column> 
            <el-table-column
              prop="scoreDownLimit"
              label="累计得分下限"
              >
              <template #default="scope">
              <span v-if="scope.row.scoreDownLimit == null">不限</span> 
            </template>
            </el-table-column> 
            <el-table-column
              label="考核频次"
              >
              <template #default="scope">
              <span v-if="scope.row.checkFrequency == 'day'">天</span> 
              <span v-if="scope.row.checkFrequency == 'week'">周</span>
              <span v-if="scope.row.checkFrequency == 'month'">月</span>
              <span v-if="scope.row.checkFrequency == 'unlimited'">不限</span>
            </template>
            </el-table-column> 
            <el-table-column
              label="状态"
              >
              <template #default="scope">
                <el-switch
                  v-model="scope.row.statusShow"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                  @change="switchClick($event,scope.row)"
                 >
                </el-switch>
              </template>
            </el-table-column> 

            <el-table-column
              label="操作"
              >
              <template #default="scope">
                            <el-button type="text"  class="lookClass" size="small" @click="BianjiBtn(scope.row)">编辑</el-button>
                            <el-button type="text"  class="lookClass" size="small" @click="queryDelete(scope.row)">删除</el-button>
               </template>
            </el-table-column> 
          </el-table>
  
          <div class="block-fenye" >
            <el-pagination
                :small="small"
                :disabled="disabled"
                :background="background"
                layout="prev, pager, next, jumper"
                :total="total"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
              />
          </div>
        </el-row>
      </div>
    </div>
      <Add v-if="ShowAdd" @back="back" :teacherObj="teacherObj"></Add>
      <Compile v-if="title == '考核修改'" @back="back" :Infoobj="Infoobj"></Compile>
    </div>
  </template>
  
  <script>
  import {GetTaskList,TaskDelete,updateStatus} from '@/assets/api/deyu.js';
  import Add from './add/index.vue'
  import Compile from './compile/index.vue'
import { ElMessage } from 'element-plus'
import { findTeacherInfo } from '@/assets/api/renyuan';


  export default {
    components: {
        Add,
        Compile,
    },
    data() {
        return {
          
          loading:true,
          form:{
            name:"",
          },
          title:'考核任务',
          tableData: [],
          pageInfo: {
            page: 1,
            pageSize: 10,
          },
          total: 0,
          ShowAdd:false,
          Infoobj:{},
          teacherObj:{}
        };
    },
    created() {
      this.Getlist()
      this.Lookteacher()

    //   this.LookTeacher()
    },
    mounted() {
  
    },
    methods: {
     Lookteacher() {
      let params = {
        userId: JSON.parse(localStorage.getItem('user')).id,
      }
      findTeacherInfo(params).then((res) => {
        // console.log(res.data.data.schoolId, '查看权限');
        this.teacherObj = res.data.data
      }).catch((err) => {
        console.log(err);
      })
    },
     switchClick (val,item) {
      let status = val?1:0
      console.log('修改',val,item);
      updateStatus(item.id,status).then((res) => {
        ElMessage({message: '修改成功',type: 'success',})

        this.Getlist()
      }).catch((err) => {
      })
    },
     addrTask(){
        this.ShowAdd = true
     },
     back(){
        this.title = '考核任务'
        this.ShowAdd = false
        this.Getlist()  


     },
    //  修改
     BianjiBtn(item){
      console.log('修改',item);
      this.Infoobj = item
      this.title = '考核修改'
      
     },
     inquiryClick(){
      this.Getlist()
     },
         // 确定删除提示
    queryDelete(row){
      this.$confirm('确定删除该任务?', '提示', {
       confirmButtonText: '确定',
       cancelButtonText: '取消',
       type: 'warning'
       }).then(() => {
           this.DeleteBtn(row)
       }).catch((err) => {
           console.log(err,'关机');
           this.$message({
               type: 'error',
               message: err.response.data.msg
           });
       });

    },
     //删除
     DeleteBtn(row){
      // console.log(row,'删除');
      TaskDelete(row.id).then((res) => {
        ElMessage({message: '删除成功',type: 'success',})
        this.Getlist()
        
      }).catch((err) => {
        ElMessage.error(err.response.data.msg || '删除失败')
      })
      
     },
      // 列表
      Getlist() {
        const params ={
          name:this.form.name,
          page:this.pageInfo.page,
          pageSize:this.pageInfo.pageSize,
          userId:JSON.parse(localStorage.getItem('user')).id,
        }
        GetTaskList(params).then((res)=> {
            this.tableData = res.data.data.list
            for(let item of this.tableData) {
              if ( item.status == 1 ) {

                item.statusShow = true
              } else {
                item.statusShow = false
              }
            }
              console.log(this.tableData,'任务管理');
            // this.total = res.data.data.total
            this.loading = false
            console.log(res.data.data.list,'任务管理');
          }).catch((err)=> {
              console.log(err);
          })
      },
      handleCurrentChange (val) {
        this.pageInfo.page = val
        this.Getlist()  
        },
        },
    };
  </script>
  
  <style scoped lang="scss">
    .fuzzy-matching-box {
      // padding-top: 35px;
      // overflow: hidden;
      // overflow: auto;
      width: 100%;
      height:  96%;
      background-color: #fff;
      border-radius: 8px;
      .Tongji-center{
        height: 100%;
      }
      .title-top {
          padding: 20px 20px;
      }
      .fuzzy-matching-top {
      height: 60px ;
      background-color: #fff;
      border-radius: 8px;
      .top-first-line {
        // justify-content: center 
        // justify-content: space-between
        justify-content: space-around;
        :deep() {
          .el-form-item--small .el-form-item__label {
            // background-color: red;
            font-size: 16px;
          }
    
          .el-form-item--small .el-form-item__label {
            width: 110px;
            text-align: right;
            height: 35px;
            line-height: 35px;          
          }
          .el-input {
            width: 100%;
            height: 35px;
          }
          .query-button{
            margin: 0;
            }
        }
      }
     
    }
    .fuzzy-matching-bottom {
      height: calc(100% - 170px);
      // overflow: auto;
      // position: relative;
      padding: 0px 20px;
      padding-top: 10px;
      margin-top: 15px;
      background-color: #fff;
      border-radius: 8px;
      .lookClass{
        font-size: 15px;
      font-weight: 700;
      } 
      
      .top-first-line {
        height: 45px;
        line-height: 45px;
          :deep(.tip-button) {
            padding: 14px 14px;
            margin: 0px 3px;
          }
        .import-export-button {
          position: absolute;
          right: 20px;
          :deep(.el-button--small) {
            padding: 16px 24px;
            border: 1px solid #569CFF;
            color: #569CFF;
          }
        }
      }
      .list {
        position: relative;
        // margin-top: 10px;
        padding-bottom: 50px;
       .fenye {
        // float: right;
        text-align: center;
       }
        :deep() {
          .el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf {
            // border: 0px;
          }
          .el-table tr {
            height: 40px;
            cursor: pointer;
            // user-select: none;
            font-size: 16px;
            color: black;
          }
           .manipulate {
            color: red;
            margin-right:15px;
            // cursor: pointer;
            // user-select: none;
          }
          .confirm,.duplicate,.revise {
            color:#1677FF;
            
          }
          .el-table th.el-table__cell>.cell {
            text-align: center;
            font-size: 16px;
            font-weight: 700;
          }
          .el-table td.el-table__cell, .fuzzy-matching-box .fuzzy-matching-bottom .list[data-v-1ddf37d1] .el-table th.el-table__cell.is-leaf {
            text-align: center;
          }
        }
        .block-fenye {
          // float: right;
          position: absolute;
          bottom: 0px;
          left: 50%;
          transform: translate(-50%,0);
          
        }
      }
    }
  }
  </style>
  